<ng-container *ngIf="!loadingRouteConfig">
  <router-outlet></router-outlet>
</ng-container>
<ng-container align="center" *ngIf="loadingRouteConfig"> ... </ng-container>
